export default "<div class=\"avatar-circle\" [style.background-color]=\"txtColor\">\r\n  <div class=\"initials\">{{name}}</div>\r\n</div>\r\n"